import React from "react";

interface GearParagraphProps {
  variant?: "small" | "medium" | "large";
  children: React.ReactNode;
  className?: string;
}

const GearParagraph: React.FC<GearParagraphProps> = ({
  variant = "medium",
  children,
  className,
}) => {
  const baseStyles = "text-base text-[#D1D5DC]";
  const variantStyles = {
    small: "text-[12px] leading-[16px]",
    medium: "text-[12px] leading-[16px] md:text-[14px] md:leading-[20px]",
    large: "text-[20px] leading-[28px]",
  };
  return (
    <p className={`${baseStyles} ${variantStyles[variant]} ${className || ""}`}>
      {children}
    </p>
  );
};

export default GearParagraph;
